var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPushArrow = function SvgIconPushArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.752 8.189a1.167 1.167 0 0 1 0-2.334h9.558a2.333 2.333 0 0 1 2.334 2.334v9.557a1.167 1.167 0 0 1-2.334 0V9.84L8.69 21.459a1.167 1.167 0 1 1-1.65-1.65l11.62-11.62z"
  })));
};
export default SvgIconPushArrow;